// extracted by mini-css-extract-plugin
export default {"modal":"MarkAsMultipleModal__modal___rAU5k"};